import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Divider, Typography,CardMedia,DialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import Confetti from 'react-confetti';
import Tour from 'reactour';
import WelcomeMessage from 'src/components/WelcomeMessage';
import {  getTourOpen, getUser, setTourOpen } from 'src/utils/Common';
import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'src/utils/axios';


const useStyles = makeStyles((theme) => ({
  root: {
  
  },
  posts: {
    marginTop: theme.spacing(2)
  },
  post: {
    marginBottom: theme.spacing(2)
  },
  icon: {
    align: 'center',
    textAlign: 'center'
  },
}));
const StyledCardMedia = styled(CardMedia)({
  height: '100%',
  width: '100%',
  backgroundSize: 'contain',
});

function Timeline({ className, ...rest }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const [openPerakendeTV, setopenPerakendeTV] = React.useState(false);
  const [avatarEmployee, setAvatarEmployee] = React.useState(null);
  const [tour, setTour] = React.useState(getTourOpen());
  const [openBirthday, setopenBirthday] = React.useState(false);
  const steps = [
    {
      content: <Typography variant="h6" gutterBottom>
        oasis Uygulamasına Hoşgeldiniz. Yönergeleri Takip Ediniz!...
      </Typography>,
    },
    {
      selector: '[data-tour="OpenNavbarButton"]',
      content: <Typography variant="h6" gutterBottom>
        Menüyü Buradan Açabilirsiniz
      </Typography>,
      position: 'left',
    },
    {
      selector: '[data-tour="LogoutButton"]',
      content: <Typography variant="h6" gutterBottom>
        Buradan Çıkış Yapabilirsiniz
      </Typography>,
      position: 'left',
    },
  ]

  const handleCloseBirthday = () => {
    setopenBirthday(false);
  };

  const PerakendeTVOpen = (event) => {
    event.persist();
    window.open("https://www.perakendetv.net/detail/F63131EE-B0F8-456A-8A90-FEF4D09ED9FF");
    event.persist();
  }
  React.useEffect(() => {
 
    if (parseInt(SessionUser.HappyBirthday) === 1) {
      setTimeout(() => {
        // setopenBirthday(true);
      }, 2000);
    }
    axios.get('/GetBanner')
    .then((response) => {
      const res = response.data;
      if (res.length === 0) {
        setopenPerakendeTV(false);
      } else {
        setAvatarEmployee(res[0].Resim);
        setopenPerakendeTV(true);
      }
    }).catch(error => {
      setopenPerakendeTV(false);
    });
  }, []);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Tour
        steps={steps}
        isOpen={tour}
        onRequestClose={() => { setTourOpen(); setTour(false) }}
        accentColor='#FF9800'
        className="helper"
        rounded={20}
      />
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
          <WelcomeMessage title="Uyarılar" messages={SessionUser.Message?.split(String.fromCharCode(10))} />
        </CardContent>
        <Divider />
      </Card>
      <Dialog
        open={openBirthday}
        onClose={handleCloseBirthday}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Confetti />
          <Typography variant="h6" component="h4">
            <br />
              Sevgili {SessionUser.NameSurname},
              <br />
            <br />
              Doğum gününü kutlar sevdiklerinle birlikte sağlık, mutluluk ve başarılarla dolu
              nice seneler dilerim.
              <br />
            <br />
              İyi ki doğdun!
              <br />
            <br />
              Sevgilerimle,
              <br />
              Hüseyin Şerif Beyaztaş
              <br />
              Arçelik Müşteri Hizmetleri Direktörü
            </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBirthday} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPerakendeTV}
        fullWidth
        maxWidth="lg"
        onClose={() => setopenPerakendeTV(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">Bilgilendirme</DialogTitle>
        <Divider />
        <DialogContent onClick={PerakendeTVOpen}>
          <StyledCardMedia
            component="img"
            alt="Banner"
            src={avatarEmployee}
          />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => setopenPerakendeTV(false)}
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>


    </div>
  );
}

Timeline.propTypes = {
  className: PropTypes.string
};

export default Timeline;
